// DO NOT EDIT -- generated from fs/services/ingestion-settings/keeprules.proto

export enum KeepPolicy {
  /** Deprecated */
  DISABLED = 0,
  PREVIEW = 1,
  ENABLED = 2,
  KEEP_ALL = 3
}
